import { BookingNotes } from "@/components/admin/BookingNotes";
import { BookingRecap } from "@/components/admin/BookingRecap";
import { BookingPayment } from "@/components/admin/BookingPayment";

const BOOKING_STATUSES = ["confirmed", "completed", "cancelled"];

function Chips({ b }) {
  return (
    <>
      {b.reminder_sent_at && <span className="dg-chip ml-2 align-middle" data-testid={`reminder-sent-${b.booking_id}`}>Reminder sent</span>}
      {b.review_sent_at && <span className="dg-chip ml-2 align-middle" data-testid={`review-sent-${b.booking_id}`}>Review asked</span>}
      {b.rebook_sent_at && <span className="dg-chip ml-2 align-middle" data-testid={`rebook-sent-${b.booking_id}`}>Rebook nudge sent</span>}
      {b.onsite_request && <span className="dg-chip ml-2 align-middle text-[#FFD600] border-[#FFD600]/50" data-testid={`onsite-requested-${b.booking_id}`}>On-site visit requested · {b.onsite_request.ticket_id}</span>}
      {b.member_tier && <span className="dg-chip ml-2 align-middle text-[#FFD600] border-[#FFD600]/50" data-testid={`member-booking-${b.booking_id}`}>Member · {b.member_tier_name}{b.payment === "membership" ? " · included session" : ` · ${b.member_discount_pct}% off`}</span>}
      {b.bonus_minutes > 0 && <span className="dg-chip ml-2 align-middle text-[#FFD600] border-[#FFD600]/50" data-testid={`bonus-minutes-${b.booking_id}`}>+{b.bonus_minutes} min · {b.bonus_reason || "birthday"}</span>}
    </>
  );
}

function feeLabel(b) {
  if (b.source === "square") return <span className="dg-chip ml-2 align-middle">Square (legacy)</span>;
  if (b.payment === "gift") return <span className="text-slate-400"> · gift code {b.gift_code}</span>;
  if (b.payment === "membership") return <span className="text-slate-400"> · included session</span>;
  return <span className="text-slate-400"> · ${Number(b.deposit_usd || 0).toFixed(2)}</span>;
}

export function BookingsList({ bookings, onStatus, onNote, onCustomer, onRecap, onRequestPayment }) {
  if (bookings.length === 0) return <div className="text-slate-500 text-sm">No bookings yet.</div>;
  const historyFor = (b) => bookings.filter((o) => o.booking_id !== b.booking_id && o.email && o.email === b.email && o.scheduled_at < b.scheduled_at);
  const statuses = (b) => (BOOKING_STATUSES.includes(b.status) ? BOOKING_STATUSES : [b.status, ...BOOKING_STATUSES]);
  return (
    <div className="space-y-3">
      {bookings.map((b) => (
        <div key={b.booking_id} className="dg-card rounded-xl p-5" data-testid={`booking-row-${b.booking_id}`}>
          <div className="flex flex-wrap items-start justify-between gap-3">
            <div>
              <div className="font-mono text-xs uppercase tracking-widest text-cyan-300">{b.booking_id}</div>
              <div className="font-display text-lg font-semibold mt-1">{b.service_name}{feeLabel(b)}<BookingPayment booking={b} onRequest={onRequestPayment} /></div>
              <div className="text-sm text-slate-300 mt-1">{new Date(b.scheduled_at).toLocaleString()}<Chips b={b} /></div>
              <div className="text-sm text-slate-400 mt-2"><button type="button" onClick={() => onCustomer?.(b.email)} className="dg-link font-semibold" data-testid={`booking-customer-${b.booking_id}`}>{b.name}</button> · <a href={`mailto:${b.email}`} className="dg-link">{b.email}</a> · <a href={`tel:${b.phone}`} className="dg-link">{b.phone}</a></div>
              <div className="text-sm text-slate-400 mt-1">{b.meeting_method || b.address}</div>
              {b.notes && <div className="text-sm text-slate-500 mt-2 italic">"{b.notes}"</div>}
            </div>
            <div className="min-w-[200px]">
              <div className="dg-eyebrow mb-1">Status</div>
              <select className="dg-input" value={b.status} onChange={(e) => onStatus(b.booking_id, e.target.value)} data-testid={`booking-status-${b.booking_id}`}>
                {statuses(b).map((s) => <option key={s} value={s}>{s.replace("_", " ")}</option>)}
              </select>
            </div>
          </div>
          <BookingNotes booking={b} history={historyFor(b)} onSave={onNote} />
          <BookingRecap booking={b} onSend={onRecap} />
        </div>
      ))}
    </div>
  );
}
